import { IconPropsType } from '..';

export const EditIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.98737 15.1823L5.87406 13.8763L2.80562 10.7921L1.49956 14.6473C1.46809 14.7417 1.45236 14.8361 1.48383 14.9306C1.56251 15.1351 1.78281 15.2453 1.98737 15.1823ZM6.55069 13.4042L3.26195 10.1155L10.3744 3.00299L13.6632 6.29172L6.55069 13.4042ZM14.2297 5.72524L15.1738 4.78111C15.6301 4.32477 15.8504 3.72682 15.8504 3.12887C15.8504 2.53092 15.6301 1.93297 15.1738 1.47663C14.7175 1.0203 14.1195 0.800003 13.5216 0.800003C12.9236 0.800003 12.3257 1.0203 11.8693 1.47663L10.9252 2.42077L14.2297 5.72524Z" />
  </svg>
);
